import { useEffect, useState } from "react";
import { connect, useDispatch } from "react-redux";
import Modal from "../../../../../../components/Modal";
import { Formik } from "formik";
import { Center } from "../../../../../../components/StyledComponents";
import {
  initialValues,
  schema,
} from "../../../../../../constants/form/academy/profile/hidden";
import Grid from "../../../../../../components/Grid";
import Button from "../../../../../../components/Button";
import Submit from "../../../../../../components/Form/Submit";
import { toast } from "react-toastify";
import academyActions from "../../../../../../store/actions/academies";
import { hideModal } from "../../../../../../store/actions/modal";
import ReactSelect from "../../../../../../components/Form/ReactSelect";
import services from "../../../../../../services";
import { AcademyDto } from "../../../../../../types/academy.dto";

const Component = ({
  selectedAcademy,
  updateAcademyStates,
  current,
  academies,
}) => {
  const [formSubmmited, setFormSubmmited] = useState(false);
  const [formActions, setFormActions] = useState<{ resetForm: () => void }>();
  const [currentAcademy, setCurrentAcademy] = useState<AcademyDto>();
  const dispatch = useDispatch();

  const onSubmit = ({ values, actions }) => {
    dispatch(academyActions.update({ _id: current.id, ...values }));
    setFormActions(actions);
  };

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response: any = await services.academy.getOne({
          _id: current.id,
        });
        setCurrentAcademy(response.response);
      } catch (err) {
        setCurrentAcademy(undefined);
      }
    };
    fetchData();
  }, []);

  useEffect(() => {
    if (updateAcademyStates.success) {
      toast("👌🏼 Academia modificada", {
        containerId: "submit",
        type: "success",
        toastId: "submitsucceful",
      });

      setTimeout(() => {
        dispatch(academyActions.resetUpdate());
        dispatch(hideModal());
        formActions?.resetForm();
      }, 1000);
    }

    if (updateAcademyStates.error) {
      toast(`😱 ${updateAcademyStates.error}`, {
        containerId: "submit",
        type: "error",
        toastId: "submiterror",
      });

      setTimeout(() => {
        dispatch(academyActions.resetUpdate());
      }, 1000);
    }
  }, [updateAcademyStates]);

  return (
    <Modal name="edit-academy-visibility" title="Visibilidad">
      {currentAcademy && (
        <Formik
          initialValues={{
            ...initialValues(
              !!currentAcademy && { private: currentAcademy.private }
            ),
          }}
          onSubmit={(values, actions) => {
            if (onSubmit) onSubmit({ values, actions });
          }}
          validateOnChange={formSubmmited}
          validateOnBlur={false}
          validationSchema={schema}
          enableReinitialize
        >
          {({
            touched,
            errors,
            values,
            handleChange,
            handleBlur,
            handleSubmit,
            resetForm,
            setFieldValue,
            isSubmitting,
          }) => {
            return (
              <form
                className="theme-form"
                onSubmit={(event) => {
                  setFormSubmmited(true);
                  handleSubmit(event);
                }}
                id="edit-academy-visibility-form"
              >
                <Grid.Row>
                  <Grid.Col>
                    <ReactSelect
                      name="private"
                      error={errors["private"]}
                      touched={touched["private"]}
                      items={[
                        {
                          label: "Privado",
                          value: true,
                        },
                        {
                          label: "Publico",
                          value: false,
                        },
                      ]}
                      placeholder="Seleccione un tipo"
                      onChange={handleChange}
                      onBlur={handleBlur}
                      options={{
                        label: "Visibilidad",
                        marginBottom: 20,
                        skin: "gray",
                      }}
                    />
                  </Grid.Col>
                </Grid.Row>

                <Grid.Row>
                  <Grid.Col>
                    <Center gap={"70px"}>
                      <Button
                        onClick={resetForm}
                        type="button"
                        options={{
                          type: "outline",
                          skin: "gray",
                          size: "lg",
                          marginBottom: "0px",
                        }}
                        style={{ marginLeft: "10px" }}
                      >
                        Cancelar
                      </Button>

                      <Submit
                        isSubmmiting={isSubmitting}
                        form="edit-academy-visibility-form"
                        color="Primary"
                        options={{
                          type: "filled",
                          skin: "primary",
                          size: "lg",
                          marginBottom: "0px",
                        }}
                      >
                        Confirmar
                      </Submit>
                    </Center>
                  </Grid.Col>
                </Grid.Row>
              </form>
            );
          }}
        </Formik>
      )}
    </Modal>
  );
};

const states = ({ academyStore, currentStore }) => {
  const { data: selectedAcademy } = academyStore.selected;
  const { states: updateAcademyStates } = academyStore.update;
  const { data: current } = currentStore;
  const { data: academies } = academyStore.all;
  return {
    selectedAcademy,
    updateAcademyStates,
    current,
    academies,
  };
};

export default connect(states)(Component);
